import * as UserGroups from './userGroups'

export const ALLOW_DASHBOARD_TAB = UserGroups.ALL_GROUPS
export const ALLOW_CONTENT_TAB = [UserGroups.EDITOR, UserGroups.MARKETING, UserGroups.CX, UserGroups.ADMIN]
export const ALLOW_CLIENT_TOOLKITS_TAB = [UserGroups.CX, UserGroups.EW, UserGroups.ADMIN, UserGroups.MARKETING]
export const ALLOW_TEMPLATES_TAB = [UserGroups.EDITOR, UserGroups.CX, UserGroups.ADMIN]
export const ALLOW_CAMPAIGN_TAB = [UserGroups.CX, UserGroups.MARKETING, UserGroups.ADMIN]
export const ALLOW_ACQUISITION_TAB = [UserGroups.CX, UserGroups.MARKETING, UserGroups.ADMIN]
export const ALLOW_REPORTING = [UserGroups.MARKETING, UserGroups.CLIENT_MANAGER, UserGroups.ADMIN]
export const ALLOW_ARK_USERS_TAB = [UserGroups.ADMIN]
export const ALLOW_CONSUMER_USERS_TAB = [UserGroups.ADMIN, UserGroups.MARKETING]
export const ALLOW_CREATE_CONTENT = [UserGroups.ADMIN, UserGroups.EDITOR, UserGroups.CX]
export const ALLOW_REMOVE_B2B_USER = [UserGroups.ADMIN, UserGroups.CX, UserGroups.CLIENT_MANAGER]
export const ALLOW_REMOVE_B2C_USER = [UserGroups.ADMIN, UserGroups.MARKETING]
export const ALLOW_ADD_BESPOKE_USER = [UserGroups.ADMIN, UserGroups.CX]
export const ALLOW_SKILL_BITES_TAB = [UserGroups.ADMIN, UserGroups.EDITOR]
export const ALLOW_ASSESSMENTS_TAB = [UserGroups.ADMIN, UserGroups.CX]
export const ALLOW_SKILLS_PRACTICE_TAB = [UserGroups.ADMIN, UserGroups.EDITOR, UserGroups.CX]
